import useFeatureToggle from 'src/hooks/use-feature-toggle';
import { CalendarToday, ExpandLess, KeyboardArrowDown, Print, Search } from '@mui/icons-material';
import {
  Avatar,
  Button,
  CardHeader,
  Chip,
  Drawer,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  SvgIcon,
  TextField,
  Tooltip,
} from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/system';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BootstrapDialog } from 'src/components/common-modals/BootstrapDialog';
import useCurrentUser from 'src/hooks/use-current-user';
import { usePageView } from 'src/hooks/use-page-view';
import { BasicDateCalendar } from 'src/layouts/components/CustomDatePicker';
import {
  getDashboardPatientInfoAction,
  getInterventionGroupAction,
  getTherapistDashboardPatientList,
} from 'src/redux/actions/therapist-dashboard-action';
import PrintPatient from './PrintPatient';
import TaskDetails from './task-deatails';
import ListingTable from './todays-activity-table';

import SchedulePrintDialog from './SchedulePrintDialog';
import { use } from 'i18next';

export const isToday = (date: any) => {
  const today = new Date();
  const dateToCheck = new Date(date);

  return (
    dateToCheck.getFullYear() === today.getFullYear() &&
    dateToCheck.getMonth() === today.getMonth() &&
    dateToCheck.getDate() === today.getDate()
  );
};

const TodaysOverview = () => {
  usePageView();
  const dispatch = useDispatch();
  const calenderRef = useRef<HTMLDivElement | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const getDashboardPatientList = useSelector((state: any) => state.getDashboardPatientReducer);
  const [providerId] = useCurrentUser(['providerId']);

  const [isUsingNewSchedulePrint] = useFeatureToggle('new-schedule-print', 'ENTERPRISE');

  const getTherapistProfile = useSelector(
    (state: any) => state.getTherapistProfileReducer?.response?.data
  );

  const listOfTherapistAvailability = useSelector(
    (state: any) => state.getListOfTherapistAvaiReducer
  );

  const [open, setOpen] = useState(false);
  const [taskInfo, setTaskInfo] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const filteredOptions = listOfTherapistAvailability?.response?.data
    ?.slice()
    .sort((a: any, b: any) => a?.lastName?.localeCompare(b?.lastName))
    .filter((therapist: any) => {
      const normalizedLabel = (therapist?.lastName + therapist?.firstName)
        ?.replace(/[\s,]/g, '')
        ?.toLowerCase();
      const normalizedSearchTerm = searchTerm?.replace(/[\s,]/g, '')?.toLowerCase();

      return normalizedLabel?.includes(normalizedSearchTerm);
    });

  const onClose = () => {
    setOpen(false);
  };

  const handleOpenDrawer = (task: any) => {
    dispatch(
      getInterventionGroupAction({
        params: {
          patientId: task?.uuid,
          type: getTherapistProfile?.discipline,
        },
      })
    );
    dispatch(
      getDashboardPatientInfoAction({
        providerId: selectedTherapist.uuid,
        date: moment(selectedDate).format('YYYY-MM-DD'),
        patientId: task?.uuid,
      })
    );
    setTaskInfo(task);
    setOpen(true);
  };

  const taskConstants: any = {
    EVALUATION: 'Evaluation',
    THERAPY: 'Therapy',
    GROUP_THERAPY: 'Group Therapy',
    INSURANCE_CALL: 'Insurance call',
    SCREENINGS: 'Screenings',
    CONCURRENT: 'Concurrent',
  };

  const [patientTaskList, setPatientTaskList] = useState<any>([]);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('patientName');

  const handleSortRequest = () => {
    const isAsc = orderBy === 'patientName' && order === 'asc';
    const formattedDate = moment(selectedDate).format('YYYY-MM-DD');

    dispatch(
      getTherapistDashboardPatientList({
        providerId: selectedTherapist?.uuid,
        date: formattedDate,
        sortDirection: isAsc ? 'desc' : 'asc',
      })
    );

    setOrder(isAsc ? 'desc' : 'asc');
  };
  useEffect(() => {
    if (getDashboardPatientList?.response?.length > 0) {
      const getPatientTaskList = getDashboardPatientList?.response
        ?.filter((patient: any) => patient?.taskMinutes !== null)
        ?.map((patient: any) => {
          const { therapyTypes, ...restPatient } = patient;
          const filterTherapyTypes = therapyTypes?.filter((types: any) => types !== null);
          const getTaskName = (therapyTypes: any) => {
            const taskNameWithValues = therapyTypes?.map((task: any) => ({
              key: task,
              value: taskConstants[task],
            }));
            return taskNameWithValues;
          };

          return {
            taskNameWithId: getTaskName(filterTherapyTypes),
            ...restPatient,
            therapyTypes,
          };
        });
      setPatientTaskList(getPatientTaskList);
    }
    if (getDashboardPatientList?.response?.length === 0) {
      return setPatientTaskList([]);
    }
  }, [getDashboardPatientList]);
  const [isPrint, setPrint] = useState(false);

  const handlePrint = () => {
    if (isUsingNewSchedulePrint) {
      console.log('NEW schedule print!');
      setIsPrintDialogOpen(true);
    } else {
      console.log('OLD schedule print!');
      setPrint((prev) => !prev);
    }
  };

  const handleClosePrintDialog = () => {
    setIsPrintDialogOpen(false);
  };

  const handleCloseInfo = () => {
    setPrint(false);
  };
  const [selectedTherapist, setSelectedTherapist] = useState<any>();
  const [anchorEl1, setAnchorEl1] = useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handelClickMenu = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  }, []);
  const handleCloseMenu = useCallback(() => {
    setAnchorEl1(null);
  }, []);

  const handleSelectedTherapist = useCallback((therapist: any) => {
    setSelectedTherapist(therapist);
    setAnchorEl1(null);
  }, []);

  useEffect(() => {
    if (getTherapistProfile?.providerId) {
      setSelectedTherapist({
        name: `${getTherapistProfile?.lastName} ${getTherapistProfile?.firstName}`,
        lastName: `${getTherapistProfile?.lastName}`,
        firstName: `${getTherapistProfile?.firstName}`,
        uuid: getTherapistProfile?.providerId,
        avatar: getTherapistProfile?.avatar,
        credentials: getTherapistProfile?.credentials,
      });
    }
  }, [getTherapistProfile]);

  const [openCalender, setOpenCalender] = useState(false);
  const [selectedDate, setSelectedDate] = useState<any>(new Date());
  const jsDate = moment(selectedDate, 'DD-MM-YYYY').toDate();
  const formattedDate = moment(jsDate).format('MMM D, YYYY');
  const scheduleDateString = moment(selectedDate).format('YYYY-MM-DD');
  const [isPrintDialogOpen, setIsPrintDialogOpen] = useState(false);
  const currentDate = moment();
  const handleClickCalender = () => {
    setOpenCalender((prev: any) => !prev);
  };

  const handleChangeDate = (e: any) => {
    setSelectedDate(new Date(e));
    setOpenCalender(false);
  };

  useEffect(() => {
    const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
    if (selectedTherapist?.uuid) {
      dispatch(
        getTherapistDashboardPatientList({
          providerId: selectedTherapist?.uuid,
          date: formattedDate,
          sortDirection: 'asc',
        })
      );
    }
  }, [selectedTherapist, selectedDate]);

  return (
    <>
      <Card>
        <CardHeader
          title={
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h6">
                  {' '}
                  {selectedTherapist?.uuid === getTherapistProfile?.providerId &&
                  isToday(selectedDate)
                    ? 'Today’s Patients'
                    : 'Schedule Patients'}{' '}
                </Typography>
                {patientTaskList?.length !== undefined && (
                  <Chip
                    label={`${patientTaskList?.length} Patients`}
                    variant="outlined"
                    sx={{ marginLeft: '10px' }}
                  />
                )}
                {/* {getTherapistProfile?.currentRoles?.includes('dor') ? ( */}
                <>
                  <Button
                    id="basic-button"
                    onClick={handelClickMenu}
                    sx={{
                      ml: 2,
                      borderColor: '#afb3ba9e',
                      color: '#111927',
                      width: 230,
                      pr: 1.5,
                      pl: 2,
                      height: '40px',
                      display: 'flex',
                      justifyContent: 'start',
                      '&:hover': {
                        color: '#111927',
                        borderColor: '#afb3ba9e',
                      },
                    }}
                    variant="outlined"
                    startIcon={
                      <Avatar
                        src={selectedTherapist?.avatar}
                        sx={{ width: 28, height: 28 }}
                      />
                    }
                    endIcon={open1 ? <ExpandLess /> : <KeyboardArrowDown />}
                    title={
                      selectedTherapist
                        ? `${selectedTherapist?.lastName} ${selectedTherapist?.firstName}`
                        : ''
                    }
                  >
                    <Typography
                      sx={{
                        width: 200,
                        fontWeight: 500,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                      }}
                    >
                      {selectedTherapist?.uuid
                        ? `${selectedTherapist?.lastName} ${selectedTherapist?.firstName}`
                        : 'Assign Therapist'}
                    </Typography>
                  </Button>
                  <Stack
                    ml={2}
                    ref={calenderRef}
                  >
                    <Button
                      sx={{
                        background: '#fff',
                        borderRadius: '12px',
                        border: '1px solid rgba(17, 25, 39, 0.16)',
                        color: '#384250',
                        '&:hover': {
                          border: '1px solid rgba(17, 25, 39, 0.16)',
                        },
                      }}
                      startIcon={
                        <SvgIcon>
                          <CalendarToday />
                        </SvgIcon>
                      }
                      variant="outlined"
                      onClick={handleClickCalender}
                    >
                      {formattedDate} {moment(jsDate).isSame(currentDate, 'day') && '(Today)'}
                    </Button>
                    {openCalender && (
                      <BasicDateCalendar
                        value={selectedDate}
                        handleChangeDate={handleChangeDate}
                      />
                    )}
                  </Stack>
                </>
              </Box>
              <Box>
                <Button
                  onClick={handlePrint}
                  startIcon={<Print />}
                  disabled={!patientTaskList?.length}
                >
                  Print
                </Button>
              </Box>
            </Box>
          }
        />
        <Box>
          <ListingTable
            handleOpenDrawer={handleOpenDrawer}
            items={patientTaskList}
            orderBy={orderBy}
            order={order}
            handleSortRequest={handleSortRequest}
          />
        </Box>
      </Card>
      {/* Schedule Print Dialog */}
      {selectedTherapist && (
        <SchedulePrintDialog
          providerUUID={selectedTherapist?.uuid}
          dateString={scheduleDateString}
          open={isPrintDialogOpen}
          onClose={handleClosePrintDialog}
        />
      )}
      <Drawer
        anchor="right"
        onClose={onClose}
        open={open}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: 532,
          },
        }}
      >
        <TaskDetails
          handleCloseDrawer={onClose}
          taskInfo={taskInfo}
          therapistUuid={selectedTherapist?.uuid}
        />
      </Drawer>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl1}
        open={open1}
        onClose={handleCloseMenu}
        sx={{
          width: '260px',
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <TextField
          variant="outlined"
          placeholder={`Search by therapist`}
          fullWidth
          onChange={(event: any) => {
            setSearchTerm(event.target.value);
          }}
          value={searchTerm}
          sx={{
            p: '0px 5px',
            '& .MuiInputBase-input': {
              padding: '12px 0px',
            },
          }}
          inputRef={inputRef}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <Grid
          height={400}
          sx={{ overflowY: 'scroll' }}
        >
          <Box sx={{ width: '220px' }}>
            {filteredOptions?.length ? (
              filteredOptions?.map((therapist: any) => (
                <MenuItem
                  key={therapist?.uuid}
                  onClick={() => handleSelectedTherapist(therapist)}
                  sx={{ display: 'flex', py: 1 }}
                >
                  <Avatar
                    src={therapist?.avatar}
                    sx={{ width: 30, height: 30 }}
                  />
                  <Tooltip
                    title={
                      therapist?.name?.length > 15
                        ? `${therapist?.lastName} ${therapist?.firstName}`
                        : ''
                    }
                  >
                    <Typography
                      sx={{
                        ml: 1,
                        overflow: 'hidden',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {`${therapist?.lastName} ${therapist?.firstName}`}
                    </Typography>
                  </Tooltip>
                </MenuItem>
              ))
            ) : (
              <Typography
                color={'text.secondary'}
                variant="subtitle2"
                sx={{
                  textAlign: 'center',
                  width: '220px',
                  p: 3,
                }}
              >
                No results found
              </Typography>
            )}
          </Box>
        </Grid>
      </Menu>

      <BootstrapDialog
        PaperProps={{ style: { maxWidth: '2250px' } }}
        onClose={() => setPrint(false)}
        aria-labelledby="customized-dialog-title"
        open={isPrint}
      >
        <PrintPatient
          close={handleCloseInfo}
          selectedTherapist={selectedTherapist}
          patientTaskList={patientTaskList}
          selectedDate={selectedDate}
        />
      </BootstrapDialog>
    </>
  );
};

export default TodaysOverview;
